import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/markets/extra-reducer';
import reducers from 'src/redux/markets/reducers';
import { marketsInitialState } from 'src/redux/markets/types';

const marketsSlice = createSlice({
  name: 'markets',
  initialState: marketsInitialState,
  reducers,
  extraReducers,
});

export const {
  setActiveMarketId,
  resetMarkets,
  setMarket,
  removeMarket,
  clearMarketListData,
  clearAssignedZips,
  clearMarketDetail,
} = marketsSlice.actions;
export default marketsSlice.reducer;
